/* eslint-disable complexity */
import { ReactElement } from "react";

// eslint-disable-next-line no-restricted-imports
import { css } from "@emotion/react";

import { media, UNSAFE_media } from "@atlaskit/primitives/responsive";
import { token } from "@atlaskit/tokens";

const containerDiv = css`
    max-width: 1200px;
    margin: 0 auto;
`;

const flexDiv = css`
    display: flex;

    ${UNSAFE_media.below.md} {
        flex-direction: column;
    }
`;

const leftContent = css`
    position: relative;
`;
const rightContent = css`
    position: relative;
`;

const rightContainer = css`
    background-color: #f4f5f7;
    min-width: 300px;
    flex: initial;
    padding-bottom: 100px;

    position: relative;
    ${media.above.md} {
        padding-top: ${token("space.250")};

        &:before {
            content: "";
            position: absolute;
            inset: 0 auto 0 0;
            width: 1000px;
            height: 100%;
            background-color: #f4f5f7;
        }
        padding: ${token("space.400")} ${token("space.300")} 0
            ${token("space.300")};
    }

    ${UNSAFE_media.below.md} {
        background-color: #ffffff;
        border-top: 1px solid #c1c7d0;
        padding-top: ${token("space.200")};
    }
`;

const leftContainer = css`
    background-color: #ffffff;
    position: relative;

    ${media.above.md} {
        padding-top: ${token("space.250")};
        padding-bottom: 100px;
        width: 75%;
        max-width: 1000px;
        padding-left: ${token("space.250")};
        &:before {
            content: "";
            position: absolute;
            inset: 0 0 0 auto;
            width: 2000px;
            height: 100%;
            background-color: #ffffff;
        }
    }

    ${UNSAFE_media.below.md} {
        padding-top: ${token("space.200")};
    }
`;

type DropdownLayoutProps = {
    main: ReactElement;
    sidebar: ReactElement;
};

export const DropdownLayout = ({ main, sidebar }: DropdownLayoutProps) => {
    return (
        <div css={containerDiv}>
            <div css={flexDiv}>
                <div css={leftContainer}>
                    <div css={leftContent}>{main}</div>
                </div>
                <div css={rightContainer}>
                    <div css={rightContent}>{sidebar}</div>
                </div>
            </div>
        </div>
    );
};
